

import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import { translations } from "../../../../translate.js";
import CircularProgress from "@material-ui/core/CircularProgress";

let Strings =
    localStorage.getItem("LANG") == 1 ? translations.Ar : translations.En;

class PayLimit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rowData: this.props.rowData,
            close: this.props.close,
            payLimit: this.props.rowData.payLimit || '',
            loadingSave: 0,
            loading: 0,
            submitError: '',
        };
    }
    componentDidMount() {
        // console.log(this.props.data[0]);
    }

    handleValidSubmit = async (event) => {
        this.setState({ loadingSave: 1 });
        event.preventDefault();
        this.setState({ loading: 1 });
        try {

            const body = {
                type: "activateEfwatercomCategories",
                lang: localStorage.getItem("LANG"),
                userId: localStorage.getItem("USER_ID"),
                token: localStorage.getItem("USER_TOKEN"),
                id: this.state.rowData.id,
                status: this.state.rowData.status || 0,
                payLimit: this.state.payLimit,
                updateType: 2
            };

            const response = await fetch(window.API_PERM_USER, {
                method: "POST",
                body: JSON.stringify(body),
                headers: {
                    Accept: "application/json",
                },
            });

            const data = await response.json();

            if (data.logout === 1) {
                localStorage.setItem("USER_ID", "");
                localStorage.setItem("USER_TOKEN", "");
                window.location.href = "/logout";
            } else if (data.error === 1) {
                this.setState({
                    submitError: data.errorMsg || Strings["An error occurred"],
                    loading: 0,
                    loadingSave: 0
                });
            } else {
                this.props.close();
                this.setState({ loading: 0, loadingSave: 0 });
            }

        } catch (error) {
            console.log(error);
            this.setState({ loading: 0, loadingSave: 0 });
        }

    };

    handleInputChange = (event) => {
        const target = event.target;
        const name = target.name;
        const value = target.value;
        this.setState({
            payLimit: value,
            submitError: "",
        });
    };




    render() {
        return (
            <div className="view-modal-style">
                <div className="sidebar-header-view">
                    <Row>
                        <Col lg={10} md={10} sm={10} xs={10}>
                            <div className="p-0 main-color-1  sidebar-header-title">
                                {" "}
                                {Strings["Edit"]} {this.state.rowData.catName}
                            </div>
                        </Col>
                        <Col lg={2} md={2} sm={2} xs={2} className="text-right">
                            <HighlightOffIcon
                                onClick={this.props.close}
                                className="modal-close-icon"
                            />
                        </Col>
                    </Row>
                </div>

                <div className="sidebar-body-view">
                    {this.state.loading == 0 && (
                        <AvForm
                            onValidSubmit={this.handleValidSubmit}
                            ref={(c) => (this.form = c)}
                        >
                            <AvField
                                name="payLimit"
                                label={Strings["Payment Limit"] + " *"}
                                placeholder={Strings["Enter"] + " " + Strings["Payment Limit"]}
                                value={this.state.payLimit}
                                required
                                type="number"
                                min={0.00001}
                                onChange={this.handleInputChange}
                                errorMessage={Strings["This field is required"]}
                            />

                            <div className="text-right mt-4">
                                {this.state.loadingSave == 1 ? (
                                    <button
                                        type="button"
                                        className="btn form-save-btn mr-1 ml-1 task-action-btn-loading"
                                    >
                                        <CircularProgress className="SaveCircularProgressColor" />{" "}
                                        {Strings["Save"]}
                                    </button>
                                ) : (
                                    <button type="submit" className="btn form-save-btn mr-1 ml-1">
                                        {" "}
                                        {Strings["Save"]}{" "}
                                    </button>
                                )}

                                <button
                                    type="button"
                                    className="btn form-cancel-btn m-l-10"
                                    onClick={this.props.close}
                                >
                                    {Strings["Cancel"]}
                                </button>
                            </div>

                            {this.state.submitError && (
                                <div className="error-text-black">
                                    <i className="flaticon2-exclamation error-icon mr-1" />{" "}
                                    {this.state.submitError}
                                </div>
                            )}
                        </AvForm>
                    )}
                    {this.state.loading == 1 && (
                        <Row>
                            <Col md={12} style={{ marginTop: "11%" }} className="text-center">
                                <div className="card-body">
                                    <div
                                        className="spinner-grow text-dark m-2 main-color-1"
                                        role="status"
                                    ></div>
                                    <div
                                        className="spinner-grow text-dark m-2 main-color-2"
                                        role="status"
                                    ></div>
                                    <div
                                        className="spinner-grow text-dark m-2 main-color-1"
                                        role="status"
                                    ></div>
                                    <div
                                        className="spinner-grow text-dark m-2 main-color-2"
                                        role="status"
                                    ></div>
                                    <div
                                        className="spinner-grow text-dark m-2 main-color-1"
                                        role="status"
                                    ></div>
                                    <div
                                        className="spinner-grow text-dark m-2 main-color-2"
                                        role="status"
                                    ></div>
                                </div>
                            </Col>
                        </Row>
                    )}
                </div>
            </div>
        );
    }
}

export default PayLimit;
